const uz = {
    meta: {
        title: "Ariza tannarxi: SEO, Google Ads va Instagram | Innobek",
        description:
            "Ariza tannarxi qanday hisoblanadi: ochiq formula, uch kanalning kuchli va zaif tomoni, CPC oraliqlari, natija chiqish muddati va byudjetni bo'lish tartibi.",
        keywords: [
            "ariza tannarxi qanday hisoblanadi",
            "lid narxi O'zbekiston",
            "SEO yoki kontekst reklama",
            "reklama byudjetini taqsimlash",
            "marketing samaradorligini o'lchash",
            "CPL va CAC hisobi",
        ],
    },
    h1: "Bitta arizaning tannarxi: uch kanalni bitta o'lchov bilan solishtirish",
    lead:
        "Kanalni «yoqdi yoki yoqmadi» bo'yicha tanlash qimmatga tushadi. To'g'ri o'lchov bitta: bitta malakali ariza sizga necha so'mga tushdi. Quyida ochiq formula, uch kanalning halol tahlili va byudjetni bo'lish tartibi bor.",
    category: "SEO va o'sish",
    readingTime: "10 daqiqa",

    body: [
        {
            type: "p",
            text:
                "Marketing byudjeti bo'yicha bahslar odatda bir xil tugaydi: kimdir «reklama pulni yeydi» deydi, kimdir «SEO natija bermaydi» deydi. Ikkalasi ham to'g'ri bo'lishi mumkin, chunki hech kim raqamni ko'rsatmayapti. Bu maqola shu raqamni hisoblash haqida.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Ariza tannarxi qanday hisoblanadi?" },
        {
            type: "p",
            text:
                "Formula juda oddiy va uni yodlab olish kifoya. Kanal bo'yicha ariza tannarxi (CPL) — shu kanalga sarflangan pulni shu kanaldan kelgan malakali arizalar soniga bo'lish.",
        },
        {
            type: "callout",
            text:
                "CPL = kanal xarajati ÷ shu kanaldan kelgan malakali arizalar soni. Xarajat ichiga faqat byudjet emas, ish haqi, agentlik to'lovi va kontent narxi ham kiradi.",
        },
        {
            type: "p",
            text:
                "Misol. Oyiga Google Ads'ga 8 000 000 so'm byudjet va 4 000 000 so'm boshqaruv haqi sarfladingiz — jami 12 000 000 so'm. Shu oyda 60 ta malakali ariza tushdi. CPL = 12 000 000 ÷ 60 = 200 000 so'm.",
        },
        {
            type: "p",
            text:
                "Eng ko'p uchraydigan xato — xarajatga faqat reklama byudjetini qo'yish. Bunda CPL sun'iy ravishda past chiqadi va kanallar taqqoslanmaydi. SEO'da byudjet umuman yo'q, lekin oylik to'lov bor; Instagram'da byudjet kichik, lekin kontent ishlab chiqarish vaqti katta.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Formula ishlashi uchun nima o'lchanishi kerak?" },
        {
            type: "p",
            text:
                "Formulaning maxraji — arizalar soni — aynan shu yerda buziladi. Agar ariza qaysi kanaldan kelganini bilmasangiz, hisob umuman qurilmaydi. O'lchash tizimi birinchi qadam, byudjet taqsimoti ikkinchi.",
        },
        {
            type: "ol",
            items: [
                "Har bir kanal havolasiga UTM belgisi qo'ying. Reklama, ijtimoiy tarmoqdagi profil havolasi, xarita profili — hammasiga.",
                "Saytdagi forma jo'natilganda UTM qiymati CRM'ga yashirin maydon sifatida tushsin. Qo'lda kiritish ishlamaydi.",
                "Qo'ng'iroqlar uchun «manba» maydonini kiriting. Eng oddiy yechim — menejer har qo'ng'iroqda «bizni qayerdan topdingiz?» deb so'rasin va javobni belgilasin.",
                "Telegram va WhatsApp havolalariga ham alohida parametr qo'ying — aks holda barcha messenjer arizalari bitta uyumga tushadi.",
                "CRM'da ariza statusini yuriting: yangi, malakali, bitim, rad. Malakali bo'lmagan arizani hisobdan chiqaring.",
            ],
        },
        {
            type: "p",
            text:
                "Bu ishning texnik qismi odatda 2–5 kun oladi va bir marta qilinadi. Usiz keyingi hamma hisob taxminga aylanadi.",
        },

        { type: "h2", text: "Malakali ariza nima?" },
        {
            type: "p",
            text:
                "Agar hisobga har qanday murojaatni qo'shsangiz, CPL chiroyli, lekin yolg'on chiqadi. Malakali ariza — sizning xizmatingizga haqiqatan mos, aloqa ma'lumoti to'g'ri va byudjeti bor murojaat.",
        },
        {
            type: "p",
            text:
                "Amaliy tavsiya: mezonni uch-to'rt bandda yozib, sotuv bo'limiga bering. Masalan — hududi mos, ehtiyoji sizning xizmatingizda, telefon javob beradi, muddat uch oy ichida. Shu to'rt shartdan uchtasi bajarilsa, ariza malakali hisoblansin.",
        },
        {
            type: "p",
            text:
                "Bu mezon kanallarni taqqoslashda hal qiluvchi bo'ladi. Ba'zi kanal arzon ariza beradi, lekin ularning yarmi malakali emas — shunda haqiqiy tannarx ikki barobar yuqori.",
        },

        { type: "h2", text: "Google Ads: kuchli va zaif tomoni" },
        {
            type: "p",
            text:
                "Kuchli tomoni — tezlik va boshqariluvchanlik. Birinchi tashriflar kampaniya yoqilgan kuniyoq keladi, birinchi arizalar odatda 3–10 kun ichida tushadi. Byudjetni istalgan kuni oshirish yoki tushirish mumkin.",
        },
        {
            type: "p",
            text:
                "Tannarxni oldindan chamalash ham mumkin. O'zbekiston bozorida oddiy tijorat so'rovlarida bosish narxi (CPC) odatda 600–2 500 so'm oralig'ida bo'ladi. Raqobati yuqori yo'nalishlarda — tibbiyot, yuridik xizmat, ko'chmas mulk, qurilish materiallari — 3 000 dan 10 000 so'mgacha chiqadi.",
        },
        {
            type: "p",
            text:
                "Shu ikki raqamdan CPL chiqariladi. Bosish 1 500 so'm, qo'nish sahifasining konversiyasi 4% bo'lsa, bitta ariza taxminan 37 500 so'mga tushadi. Konversiyani 6% ga ko'tarish tannarxni 25 000 so'mga tushiradi — shuning uchun sahifa ustida ishlash reklama sozlashdan kam ahamiyatli emas.",
        },
        {
            type: "p",
            text:
                "Zaif tomoni ham aniq: reklama to'xtaganda ariza oqimi ham to'xtaydi. SEO'da qilingan ish saytda qoladi, reklamada esa byudjet tugagan kuni grafik nolga tushadi. Ikkinchi cheklov — minimal hajm: oyiga 8 000 000 so'mdan kam byudjet bilan algoritm o'rganish uchun ma'lumot to'plamaydi.",
        },

        { type: "h2", text: "SEO: kuchli va zaif tomoni" },
        {
            type: "p",
            text:
                "Kuchli tomoni — vaqt o'tishi bilan tannarxning tushishi. Reklamada har yangi ariza uchun qaytadan to'laysiz; SEO'da esa bir marta yozilgan sahifa oylar davomida ariza keltiradi. Oltinchi oydan keyin CPL odatda sezilarli pasayadi.",
        },
        {
            type: "p",
            text:
                "Zaif tomoni ham xuddi shu darajada aniq va biz buni har shartnomadan oldin aytamiz: SEO tez natija bermaydi. Birinchi sezilarli o'zgarishlar 2–3 oydan oldin ko'rinmaydi, jiddiy o'sish esa 5–9 oy oralig'ida keladi. Raqobati yuqori sohalarda bu muddat bir yilgacha cho'ziladi.",
        },
        {
            type: "p",
            text:
                "Shu sababli SEO'ning CPL'ini birinchi oyda hisoblash mantiqsiz. Nol arizani 6 000 000 so'mga bo'lsangiz, cheksizlik chiqadi. To'g'ri usul — xarajatni kamida olti oy bo'yicha yig'ib, o'sha davrdagi umumiy ariza soniga bo'lish.",
        },
        {
            type: "p",
            text:
                "Ikkinchi cheklov — SEO hamma so'rovni qamrab ololmaydi. Yangi mahsulot yoki hali qidiruvda so'rovi shakllanmagan xizmat uchun organik trafik oddiygina mavjud emas. Bu holatda reklama va ijtimoiy tarmoq talabni o'zi yaratishi kerak.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Instagram: kuchli va zaif tomoni" },
        {
            type: "p",
            text:
                "Auditoriya hajmi bo'yicha tarqalayotgan raqamlarni bu yerda keltirmaymiz: rasmiy manbada tasdiqlangan ma'lumot topilmadi, agentlik hisobotidagi raqamni esa fakt sifatida ishlatish noto'g'ri. Shuning uchun faqat sifat jihatlarini yozamiz.",
        },
        {
            type: "p",
            text:
                "Kuchli tomoni — talabni yaratish. Odam Instagram'ga sizni qidirib kirmaydi, lekin ko'rgan narsasi yoqsa, ehtiyoj o'sha yerda paydo bo'ladi. Vizual mahsulotlar — kiyim, ta'mir, go'zallik, ovqat, mebel — shu kanalda yaxshi ishlaydi.",
        },
        {
            type: "p",
            text:
                "Zaif tomoni uchta. Birinchisi — o'lchash qiyin: ariza ko'pincha shaxsiy xabarda keladi va manbasi CRM'ga tushmaydi. Ikkinchisi — kontent yuki: bu kanal pul emas, vaqt yeydi, va u ish haqi shaklida CPL'ga kirishi kerak. Uchinchisi — bu ijaraga olingan auditoriya: algoritm o'zgarsa yoki akkaunt bloklansa, kanal bir kechada yo'qoladi.",
        },
        {
            type: "p",
            text:
                "Amaliy qoida: Instagram arizalarini o'lchash uchun profildagi havolaga UTM qo'ying va shaxsiy xabardan kelgan murojaatlarni menejer alohida belgilasin. Shundagina bu kanalning haqiqiy tannarxi ko'rinadi.",
        },

        { type: "h2", text: "Uch kanalni yonma-yon qanday solishtirish kerak?" },
        {
            type: "p",
            text:
                "Quyidagi jadval taqqoslash ramkasi. Tannarx ustunini o'zingiz to'ldirasiz — universal raqam yo'q, u sohangizga bog'liq.",
        },
        {
            type: "table",
            head: ["Kanal", "Xarajat tarkibi", "Natija qachon chiqadi", "O'lchash usuli", "Asosiy xavf"],
            rows: [
                [
                    "Google Ads",
                    "Reklama byudjeti + sozlash + boshqaruv haqi",
                    "Birinchi arizalar 3–10 kun, barqaror natija 2-oydan",
                    "UTM, konversiya kuzatuvi, CRM manba maydoni",
                    "To'xtatilsa oqim darhol nolga tushadi",
                ],
                [
                    "SEO",
                    "Oylik xizmat haqi + kontent + texnik tuzatishlar",
                    "Birinchi o'zgarish 2–3 oy, sezilarli o'sish 5–9 oy",
                    "Search Console, organik segment, CRM manba maydoni",
                    "Sekin; algoritm o'zgarishi pozitsiyaga ta'sir qiladi",
                ],
                [
                    "Instagram",
                    "Kontent ishlab chiqarish vaqti + SMM ish haqi + targeting byudjeti",
                    "Bir necha hafta, kontent muntazam bo'lsa",
                    "Profil havolasidagi UTM, shaxsiy xabar belgisi",
                    "Ijaraga olingan auditoriya; o'lchash to'liq emas",
                ],
                [
                    "Xarita profili",
                    "Sozlash + oylik yuritish",
                    "Bir necha hafta ichida qo'ng'iroqlar",
                    "Profil hisoboti, UTM, qo'ng'iroq manbasi",
                    "Hajmi cheklangan — faqat yaqin atrof",
                ],
            ],
        },
        {
            type: "p",
            text:
                "Jadvalni to'ldirgach, ko'pincha kutilmagan natija chiqadi: eng arzon ariza xarita profilidan keladi, eng ko'p ariza reklamadan, eng foydali mijoz esa organik qidiruvdan. Shuning uchun bitta kanalni tanlash emas, ularning nisbatini boshqarish kerak.",
        },

        { type: "h2", text: "Ikkinchi qavat: bitta mijoz qancha turadi?" },
        {
            type: "p",
            text:
                "Ariza tannarxi yakuniy raqam emas. Undan keyin ikkinchi konversiya bor: arizadan bitimga. Bitta mijozni jalb qilish narxi (CAC) ana shu yerdan chiqadi.",
        },
        {
            type: "ol",
            items: [
                "Kanal CPL'i 200 000 so'm.",
                "Arizadan bitimga o'tish 20% — beshta arizadan bittasi mijozga aylanadi.",
                "CAC = 200 000 ÷ 0,2 = 1 000 000 so'm.",
                "O'rtacha chek 6 000 000 so'm, marja 30% — bitta mijozdan 1 800 000 so'm sof foyda.",
                "Kanal foydali: har 1 000 000 so'm xarajatga 1 800 000 so'm qaytadi.",
            ],
        },
        {
            type: "p",
            text:
                "Xuddi shu hisobni har kanal uchun alohida qiling. Ko'pincha ma'lum bo'ladiki, qimmat ariza beradigan kanal aslida foydaliroq — chunki uning arizalari ko'proq bitimga aylanadi.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "O'lchamaslikning narxi qancha?" },
        {
            type: "p",
            text:
                "O'lchash tizimi yo'q kompaniya byudjetni his-tuyg'u bo'yicha taqsimlaydi. Amaliyotda bu odatda bitta natijaga olib keladi: ishlamayotgan kanal moliyalashda davom etadi, ishlayotgani esa kam oladi.",
        },
        {
            type: "p",
            text:
                "Raqam bilan ko'rsatamiz. Oylik marketing byudjeti 20 000 000 so'm bo'lsin va uning 30% i haqiqatda ariza keltirmaydigan kanalga ketayotgan bo'lsin. Bu oyiga 6 000 000 so'm, yiliga 72 000 000 so'm. O'lchash tizimini o'rnatish esa bir martalik va ancha arzon ish.",
        },

        { type: "h2", text: "Bu hisob qachon ishlamaydi?" },
        {
            type: "p",
            text:
                "Halol bo'lish uchun formulaning chegaralarini ham aytish kerak. Quyidagi holatlarda CPL bo'yicha qaror qabul qilish xato bo'ladi.",
        },
        {
            type: "list",
            items: [
                "Ma'lumot hajmi kichik. Oyiga 5 ta ariza bo'lsa, CPL tasodifga bog'liq bo'ladi. Kamida 30–40 ta ariza to'planmaguncha xulosa chiqarmang.",
                "Sotuv sikli uzun. B2B'da ariza olti oydan keyin bitimga aylanishi mumkin — bu oyning CPL'i o'sha oy daromadi bilan solishtirilmaydi.",
                "Kanallar bir-biriga ta'sir qiladi. Odam reklamani ko'radi, keyin nomingizni qidiruvda yozadi va organikdan kiradi. Oxirgi kanal butun ishni o'ziga yozib oladi.",
                "Brend bosqichida. Yangi kompaniya birinchi oylarda tanilish uchun sarflaydi va bu darhol arizaga aylanmaydi.",
                "Ariza sifati o'lchanmaydi. Malakali ariza mezoni yo'q bo'lsa, CPL chiroyli bo'ladi-yu, sotuv o'smaydi.",
            ],
        },
        {
            type: "p",
            text:
                "Xulosa bitta: birinchi qadam byudjetni bo'lish emas, o'lchash tizimini o'rnatish. Ikkinchi oydan boshlab raqamlar o'zi qaysi kanalga pul qo'yish kerakligini aytadi — va bu qaror bahsdan ancha arzon chiqadi.",
        },
        {
            type: "quote",
            text:
                "Kanalni yoqtirish yoki yoqtirmaslik mumkin emas. Uni faqat hisoblash mumkin.",
        },
    ],

    faq: [
        {
            q: "Ariza tannarxi qanday formula bilan hisoblanadi?",
            a: "CPL = kanal xarajati ÷ shu kanaldan kelgan malakali arizalar soni. Xarajatga faqat reklama byudjeti emas, sozlash haqi, agentlik to'lovi, kontent va shu kanal bilan shug'ullanadigan xodim ish haqi ham kiritiladi. Aks holda kanallar bir xil o'lchovda taqqoslanmaydi va SEO sun'iy ravishda qimmat, Instagram esa sun'iy ravishda arzon ko'rinadi.",
        },
        {
            q: "O'zbekistonda bitta bosish qancha turadi?",
            a: "Oddiy tijorat so'rovlarida Google Ads'dagi bosish narxi odatda 600–2 500 so'm oralig'ida bo'ladi. Raqobati yuqori yo'nalishlarda — tibbiyot, yuridik xizmat, ko'chmas mulk, qurilish — 3 000 dan 10 000 so'mgacha chiqishi mumkin. Aniq raqam auksion, raqobatchilar stavkasi va e'lon sifat ko'rsatkichiga bog'liq, shuning uchun uni sohangiz bo'yicha alohida tekshirish kerak.",
        },
        {
            q: "SEO'ning ariza tannarxini birinchi oyda hisoblasa bo'ladimi?",
            a: "Yo'q va bunga urinish noto'g'ri xulosaga olib keladi. SEO'da birinchi sezilarli o'zgarishlar 2–3 oydan oldin ko'rinmaydi, sezilarli o'sish esa 5–9 oy oralig'ida keladi. Shuning uchun xarajatni kamida olti oylik davr bo'yicha yig'ib, o'sha davrdagi umumiy ariza soniga bo'ling. Faqat shunda raqam haqiqatni ko'rsatadi.",
        },
        {
            q: "Instagram arizalarini qanday o'lchash kerak?",
            a: "Profildagi havolaga UTM belgisi qo'ying, shunda saytga o'tishlar analitikada alohida ko'rinadi. Shaxsiy xabardan kelgan murojaatlarni esa menejer CRM'da alohida manba sifatida belgilasin. Xarajatga byudjetdan tashqari kontent ishlab chiqarish vaqti va SMM mutaxassisining ish haqi ham qo'shilsin — bu kanalda asosiy xarajat aynan shu yerda.",
        },
        {
            q: "Byudjetni kanallar orasida qanday nisbatda bo'lish kerak?",
            a: "Universal nisbat yo'q va uni birinchi oyda topib ham bo'lmaydi. To'g'ri tartib boshqacha: avval o'lchash tizimini o'rnating, ikki oy ma'lumot to'plang, keyin byudjetni CPL va bitimga o'tish ulushi bo'yicha qayta taqsimlang. Natija chiqmagan kanalni yopish emas, avval undagi o'lchash to'g'ri ishlayotganini tekshiring.",
        },
        {
            q: "Qaysi kanaldan boshlash kerak?",
            a: "Agar natija shu chorakda kerak bo'lsa — kontekst reklamadan, chunki u eng tez ishga tushadi va qaysi so'rovlar pul keltirishini tez ko'rsatadi. Agar gorizont bir yildan uzun bo'lsa, SEO'ni parallel boshlang: u sekin, lekin oltinchi oydan keyin ariza tannarxini tushiradi. Offlayn nuqtangiz bo'lsa, birinchi qadam — xarita profili.",
        },
    ],

    cta: {
        h: "Kanallaringiz bo'yicha ariza tannarxini birga hisoblaymiz",
        p:
            "Mavjud ma'lumotingizni ko'rib, qaysi kanal qancha turayotganini va qayerda pul behuda ketayotganini ko'rsatamiz. Agar muammo kanalda emas, o'lchashda bo'lsa — buni ham ochiq aytamiz.",
        button: "Hisobni so'rash",
    },

    images: [
        {
            src: "/assets/img/blog/ariza-tannarxi-kanallar.webp",
            alt: "Uchta kanaldan kelayotgan arizalarning bitta tizimga tushishini ko'rsatuvchi sxema",
            caption: "Kanallar har xil, o'lchov esa bitta bo'lishi kerak",
            prompt:
                "Three funnels side by side feeding into one CRM inbox: organic search, paid ads and social, each funnel with a different width and a cost tag at the top; clean flat infographic, blue, amber and violet channels, light background, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ariza-tannarxi-formula.webp",
            alt: "Ariza tannarxi va mijoz jalb qilish narxi formulasi ko'rsatilgan panel",
            caption: "CPL — birinchi qavat, CAC — ikkinchi qavat",
            prompt:
                "Cost-per-lead formula panel: inputs channel spend and qualified leads, output CPL tile, with a second row extending to lead-to-deal conversion and customer acquisition cost; clean light dashboard, numeric placeholders shown as dashes, blue and green, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ariza-tannarxi-muddat.webp",
            alt: "Kanallar bo'yicha natija chiqish muddatining taqqoslangan grafigi",
            caption: "Reklama darhol, ijtimoiy tarmoq haftalarda, SEO 2–3 oydan keyin",
            prompt:
                "Time-to-result comparison chart: three horizontal bars showing when each channel starts producing leads — ads immediately, social after several weeks, SEO after several months with a long continuing tail; clean timeline chart on light background, month axis, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/qurilish-lead.webp",
            alt: "Qurilish kompaniyasi uchun lid oqimi va saytdagi ariza formasi",
            caption: "Ariza CRM'ga manbasi bilan tushmasa, hisob qurilmaydi",
        },
    ],

    relatedServices: ["google-ads", "seo", "crm-tizimlar"],
    relatedPosts: ["ozbekistonda-ikki-tilli-seo", "google-business-profil-yaqin-atrofda", "web-sayt"],
};

const ru = {
    meta: {
        title: "Стоимость заявки: SEO, Google Ads и Instagram | Innobek",
        description:
            "Как считать стоимость заявки: открытая формула CPL, сильные и слабые стороны трёх каналов, диапазоны CPC, сроки результата и порядок распределения бюджета.",
        keywords: [
            "как считать стоимость заявки CPL",
            "стоимость лида Узбекистан",
            "SEO или контекстная реклама что выбрать",
            "распределение рекламного бюджета",
            "как измерять эффективность маркетинга",
            "CPL и CAC расчёт",
        ],
    },
    h1: "Стоимость одной заявки: как сравнить три канала одной меркой",
    lead:
        "Выбирать канал по принципу «нравится или нет» дорого обходится. Корректная мерка одна: во сколько сум вам обошлась одна квалифицированная заявка. Ниже открытая формула, честный разбор трёх каналов и порядок распределения бюджета.",
    category: "SEO и рост",
    readingTime: "10 минут",

    body: [
        {
            type: "p",
            text:
                "Споры о маркетинговом бюджете обычно заканчиваются одинаково: кто-то говорит, что реклама съедает деньги, кто-то — что SEO не даёт результата. Оба могут быть правы, потому что никто не показывает цифру. Эта статья как раз про то, как её посчитать.",
        },
        { type: "image", image: 0 },

        { type: "h2", text: "Как считается стоимость заявки?" },
        {
            type: "p",
            text:
                "Формула предельно простая, её достаточно запомнить один раз. Стоимость заявки по каналу (CPL) — это расходы на канал, делённые на количество квалифицированных заявок из этого канала.",
        },
        {
            type: "callout",
            text:
                "CPL = расходы на канал ÷ количество квалифицированных заявок из него. В расходы входит не только бюджет, но и зарплаты, оплата агентства и производство контента.",
        },
        {
            type: "p",
            text:
                "Пример. За месяц в Google Ads ушло 8 000 000 сум бюджета и 4 000 000 сум за ведение — итого 12 000 000 сум. За тот же месяц пришло 60 квалифицированных заявок. CPL = 12 000 000 ÷ 60 = 200 000 сум.",
        },
        {
            type: "p",
            text:
                "Самая частая ошибка — учитывать в расходах только рекламный бюджет. Тогда CPL получается искусственно низким и каналы становятся несравнимыми. В SEO бюджета нет вовсе, но есть ежемесячная оплата; в Instagram бюджет маленький, зато производство контента съедает много рабочего времени.",
        },
        { type: "image", image: 1 },

        { type: "h2", text: "Что нужно измерять, чтобы формула работала?" },
        {
            type: "p",
            text:
                "Чаще всего формула ломается в знаменателе — в количестве заявок. Если неизвестно, из какого канала пришла заявка, расчёт не собирается вообще. Система измерения идёт первым шагом, распределение бюджета — вторым.",
        },
        {
            type: "ol",
            items: [
                "Поставьте UTM-метки на ссылки всех каналов: рекламу, ссылку в профиле соцсети, профиль на карте.",
                "При отправке формы значение UTM должно попадать в CRM скрытым полем. Ручное заполнение не работает.",
                "Для звонков заведите поле «источник». Самое простое решение: менеджер спрашивает, откуда о вас узнали, и отмечает ответ.",
                "Ссылкам в Telegram и WhatsApp тоже задайте отдельный параметр — иначе все обращения из мессенджеров сольются в одну кучу.",
                "Ведите статусы заявок: новая, квалифицированная, сделка, отказ. Неквалифицированные из расчёта исключаются.",
            ],
        },
        {
            type: "p",
            text:
                "Техническая часть этой работы обычно занимает 2–5 дней и делается один раз. Без неё все последующие расчёты превращаются в догадки.",
        },

        { type: "h2", text: "Какая заявка считается квалифицированной?" },
        {
            type: "p",
            text:
                "Если в расчёт попадает любое обращение, CPL выйдет красивым, но неверным. Квалифицированная заявка — это обращение, которое действительно подходит под вашу услугу, с корректными контактами и реальным бюджетом.",
        },
        {
            type: "p",
            text:
                "Практическая рекомендация: опишите критерий в трёх-четырёх пунктах и передайте его отделу продаж. Например: подходящий регион, потребность в вашей услуге, клиент отвечает на звонок, срок принятия решения до трёх месяцев. Если выполняются три условия из четырёх, заявка считается квалифицированной.",
        },
        {
            type: "p",
            text:
                "При сравнении каналов этот критерий оказывается решающим. Какой-то канал даёт дешёвые заявки, но половина из них не проходит квалификацию — и реальная стоимость заявки там вдвое выше заявленной.",
        },

        { type: "h2", text: "Google Ads: сильные и слабые стороны" },
        {
            type: "p",
            text:
                "Сильная сторона — скорость и управляемость. Первые переходы на сайт появляются в день запуска, первые заявки обычно в течение 3–10 дней. Бюджет можно увеличить или сократить в любой день.",
        },
        {
            type: "p",
            text:
                "Стоимость заявки здесь прогнозируется заранее. На рынке Узбекистана по обычным коммерческим запросам стоимость клика держится в диапазоне 600–2 500 сум. В конкурентных направлениях — медицина, юридические услуги, недвижимость, стройматериалы — доходит до 3 000–10 000 сум.",
        },
        {
            type: "p",
            text:
                "Из этих двух чисел и выводится CPL. При клике 1 500 сум и конверсии посадочной страницы 4% одна заявка обойдётся примерно в 37 500 сум. Рост конверсии до 6% снижает эту цифру до 25 000 сум — поэтому работа над страницей важна не меньше настройки самой рекламы.",
        },
        {
            type: "p",
            text:
                "Слабая сторона тоже очевидна: как только реклама останавливается, поток заявок обнуляется. Работа, вложенная в SEO, остаётся на сайте, а здесь график падает в день окончания бюджета. Второе ограничение — минимальный объём: при бюджете меньше 8 000 000 сум в месяц алгоритму не хватает данных для обучения.",
        },

        { type: "h2", text: "SEO: сильные и слабые стороны" },
        {
            type: "p",
            text:
                "Сильная сторона — снижение стоимости заявки со временем. В рекламе вы платите за каждую новую заявку заново; в SEO однажды написанная страница приносит обращения месяцами. С шестого месяца CPL обычно заметно падает.",
        },
        {
            type: "p",
            text:
                "Слабая сторона столь же очевидна, и мы проговариваем её до подписания договора: SEO не даёт быстрого результата. Первые заметные изменения появляются не раньше 2–3 месяцев, серьёзный рост приходит в диапазоне 5–9 месяцев. В высококонкурентных нишах срок растягивается до года.",
        },
        {
            type: "p",
            text:
                "Поэтому считать CPL по SEO в первый месяц бессмысленно. Если разделить 6 000 000 сум на ноль заявок, получится бесконечность. Корректный способ — суммировать расходы минимум за шесть месяцев и разделить на общее количество заявок за этот период.",
        },
        {
            type: "p",
            text:
                "Второе ограничение: SEO закрывает не любой спрос. Для нового продукта или услуги, спрос на которые в поиске ещё не сформировался, органического трафика просто не существует. В такой ситуации спрос приходится создавать рекламой и социальными сетями.",
        },
        { type: "image", image: 2 },

        { type: "h2", text: "Instagram: сильные и слабые стороны" },
        {
            type: "p",
            text:
                "Цифры по размеру аудитории мы здесь приводить не будем: подтверждения в официальном источнике найти не удалось, а использовать показатель из отчёта агентства как факт некорректно. Поэтому ограничимся качественной оценкой.",
        },
        {
            type: "p",
            text:
                "Сильная сторона — формирование спроса. В Instagram человек не ищет вас целенаправленно, но если увиденное нравится, потребность возникает прямо там. Визуальные ниши — одежда, ремонт, красота, еда, мебель — работают в этом канале хорошо.",
        },
        {
            type: "p",
            text:
                "Слабых сторон три. Первая — сложность измерения: заявка часто приходит в личные сообщения и в CRM с источником не попадает. Вторая — контентная нагрузка: канал съедает не деньги, а время, и оно должно входить в CPL в виде зарплаты. Третья — это арендованная аудитория: смена алгоритма или блокировка аккаунта обнуляют канал за сутки.",
        },
        {
            type: "p",
            text:
                "Рабочее правило: поставьте UTM на ссылку в профиле, а обращения из личных сообщений менеджер должен отмечать отдельным источником. Только тогда реальная стоимость заявки из этого канала станет видимой.",
        },

        { type: "h2", text: "Как сравнивать три канала рядом?" },
        {
            type: "p",
            text:
                "Таблица ниже — рамка для сравнения. Колонку со стоимостью заявки вы заполняете сами: универсальной цифры не существует, она зависит от ниши.",
        },
        {
            type: "table",
            head: ["Канал", "Состав расходов", "Когда появляется результат", "Способ измерения", "Главный риск"],
            rows: [
                [
                    "Google Ads",
                    "Рекламный бюджет + настройка + ведение",
                    "Первые заявки 3–10 дней, стабильность со 2-го месяца",
                    "UTM, отслеживание конверсий, поле источника в CRM",
                    "При остановке поток мгновенно обнуляется",
                ],
                [
                    "SEO",
                    "Ежемесячная оплата + контент + технические правки",
                    "Первые изменения 2–3 месяца, рост 5–9 месяцев",
                    "Search Console, органический сегмент, поле источника",
                    "Медленно; изменения алгоритмов влияют на позиции",
                ],
                [
                    "Instagram",
                    "Время на контент + зарплата SMM + бюджет на таргет",
                    "Несколько недель при регулярном контенте",
                    "UTM в ссылке профиля, отметка обращений из личных сообщений",
                    "Арендованная аудитория; измерение неполное",
                ],
                [
                    "Профиль на карте",
                    "Настройка + ежемесячное ведение",
                    "Звонки в течение нескольких недель",
                    "Отчёт профиля, UTM, источник звонка",
                    "Ограниченный объём — только ближняя география",
                ],
            ],
        },
        {
            type: "p",
            text:
                "После заполнения таблицы результат часто оказывается неожиданным: самая дешёвая заявка приходит с карты, самый большой объём — из рекламы, а самый выгодный клиент — из органического поиска. Поэтому задача не выбрать один канал, а управлять их соотношением.",
        },

        { type: "h2", text: "Второй этаж: во сколько обходится один клиент?" },
        {
            type: "p",
            text:
                "Стоимость заявки — ещё не итоговая цифра. За ней следует вторая конверсия: из заявки в сделку. Именно отсюда выводится стоимость привлечения клиента (CAC).",
        },
        {
            type: "ol",
            items: [
                "CPL по каналу — 200 000 сум.",
                "Конверсия из заявки в сделку 20%: клиентом становится одна заявка из пяти.",
                "CAC = 200 000 ÷ 0,2 = 1 000 000 сум.",
                "Средний чек 6 000 000 сум при марже 30% — 1 800 000 сум чистой прибыли с клиента.",
                "Канал прибыльный: на каждый вложенный 1 000 000 сум возвращается 1 800 000 сум.",
            ],
        },
        {
            type: "p",
            text:
                "Этот же расчёт нужно провести отдельно по каждому каналу. Часто выясняется, что канал с более дорогой заявкой на деле выгоднее — просто его заявки чаще доходят до сделки.",
        },
        { type: "image", image: 3 },

        { type: "h2", text: "Сколько стоит не измерять?" },
        {
            type: "p",
            text:
                "Компания без системы измерения распределяет бюджет по ощущениям. На практике это почти всегда приводит к одному: неработающий канал продолжает финансироваться, а работающий получает меньше положенного.",
        },
        {
            type: "p",
            text:
                "Посчитаем. Пусть месячный маркетинговый бюджет составляет 20 000 000 сум и 30% его уходит в канал, который заявок фактически не приносит. Это 6 000 000 сум в месяц и 72 000 000 сум в год. Настройка измерения при этом — разовая работа, и стоит она несопоставимо меньше.",
        },

        { type: "h2", text: "Когда этот расчёт не работает?" },
        {
            type: "p",
            text:
                "Честности ради нужно назвать и границы формулы. В перечисленных ниже ситуациях принимать решение по CPL будет ошибкой.",
        },
        {
            type: "list",
            items: [
                "Мало данных. При пяти заявках в месяц CPL зависит от случайности. Не делайте выводов, пока не накопится хотя бы 30–40 заявок.",
                "Длинный цикл сделки. В B2B заявка может закрыться через полгода, и CPL текущего месяца не сопоставим с выручкой того же месяца.",
                "Каналы влияют друг на друга. Человек видит рекламу, затем набирает ваше название в поиске и приходит из органики — и вся заслуга записывается на последний канал.",
                "Стадия построения бренда. Новая компания первые месяцы платит за узнаваемость, и это не превращается в заявки мгновенно.",
                "Качество заявок не измеряется. Без критерия квалификации CPL выглядит отлично, а продажи не растут.",
            ],
        },
        {
            type: "p",
            text:
                "Вывод один: первый шаг — не деление бюджета, а настройка измерения. Со второго месяца цифры сами покажут, куда вкладывать деньги, и это решение обойдётся заметно дешевле любых споров.",
        },
        {
            type: "quote",
            text:
                "Канал нельзя любить или не любить. Его можно только посчитать.",
        },
    ],

    faq: [
        {
            q: "По какой формуле считается стоимость заявки?",
            a: "CPL = расходы на канал ÷ количество квалифицированных заявок из него. В расходы включается не только рекламный бюджет, но и оплата настройки, комиссия агентства, производство контента и зарплата сотрудника, который ведёт канал. Иначе каналы измеряются разными мерками: SEO выглядит искусственно дорогим, а Instagram — искусственно дешёвым.",
        },
        {
            q: "Сколько стоит клик в Узбекистане?",
            a: "По обычным коммерческим запросам стоимость клика в Google Ads обычно держится в диапазоне 600–2 500 сум. В конкурентных нишах — медицина, юридические услуги, недвижимость, строительство — она доходит до 3 000–10 000 сум. Точная цифра зависит от аукциона, ставок конкурентов и показателя качества объявления, поэтому проверять её нужно отдельно по вашей нише.",
        },
        {
            q: "Можно ли посчитать CPL по SEO в первый месяц?",
            a: "Нет, и попытка это сделать приведёт к неверному выводу. Первые заметные изменения в SEO появляются не раньше 2–3 месяцев, ощутимый рост — в диапазоне 5–9 месяцев. Поэтому расходы нужно суммировать минимум за полгода и делить на общее число заявок за этот же период. Только тогда цифра отражает реальность.",
        },
        {
            q: "Как измерять заявки из Instagram?",
            a: "Поставьте UTM-метку на ссылку в профиле — тогда переходы на сайт будут видны в аналитике отдельно. Обращения из личных сообщений менеджер должен отмечать в CRM как отдельный источник. В расходы, помимо бюджета на продвижение, обязательно включите время на производство контента и зарплату SMM-специалиста: основные затраты канала именно там.",
        },
        {
            q: "В какой пропорции делить бюджет между каналами?",
            a: "Универсальной пропорции нет, и в первый месяц её не найти. Правильный порядок другой: сначала настроить измерение, два месяца накапливать данные, затем перераспределить бюджет по CPL и доле доведённых до сделки заявок. Канал без результата не закрывайте сразу — сперва проверьте, корректно ли в нём работает измерение.",
        },
        {
            q: "С какого канала начинать?",
            a: "Если результат нужен в этом квартале — с контекстной рекламы: она запускается быстрее всех и сразу показывает, какие запросы приносят деньги. Если горизонт длиннее года, параллельно начинайте SEO: оно медленное, но с шестого месяца снижает стоимость заявки. При наличии офлайн-точки первым шагом будет профиль на карте.",
        },
    ],

    cta: {
        h: "Вместе посчитаем стоимость заявки по вашим каналам",
        p:
            "Разберём имеющиеся данные и покажем, сколько на самом деле стоит каждый канал и где бюджет расходуется впустую. Если проблема не в канале, а в измерении, скажем об этом прямо.",
        button: "Запросить расчёт",
    },

    images: [
        {
            src: "/assets/img/blog/ariza-tannarxi-kanallar.webp",
            alt: "Схема потока заявок из трёх каналов в одну систему учёта",
            caption: "Каналы разные, а мерка должна быть одна",
            prompt:
                "Three funnels side by side feeding into one CRM inbox: organic search, paid ads and social, each funnel with a different width and a cost tag at the top; clean flat infographic, blue, amber and violet channels, light background, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ariza-tannarxi-formula.webp",
            alt: "Панель с формулой стоимости заявки и стоимости привлечения клиента",
            caption: "CPL — первый этаж расчёта, CAC — второй",
            prompt:
                "Cost-per-lead formula panel: inputs channel spend and qualified leads, output CPL tile, with a second row extending to lead-to-deal conversion and customer acquisition cost; clean light dashboard, numeric placeholders shown as dashes, blue and green, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/ariza-tannarxi-muddat.webp",
            alt: "График сравнения сроков появления результата по каналам продвижения",
            caption: "Реклама сразу, соцсети за недели, SEO не раньше 2–3 месяцев",
            prompt:
                "Time-to-result comparison chart: three horizontal bars showing when each channel starts producing leads — ads immediately, social after several weeks, SEO after several months with a long continuing tail; clean timeline chart on light background, month axis, no readable text, no logos, 16:9",
        },
        {
            src: "/assets/img/blog/qurilish-lead.webp",
            alt: "Поток лидов и форма заявки на сайте строительной компании",
            caption: "Если заявка попадает в CRM без источника, расчёт не собрать",
        },
    ],

    relatedServices: ["google-ads", "seo", "crm-tizimlar"],
    relatedPosts: ["ozbekistonda-ikki-tilli-seo", "google-business-profil-yaqin-atrofda", "web-sayt"],
};

const content = { uz, ru };

export default content;
